<template>
    <div class="w-full grid gap-4" :class="responsiveGridClasses">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'ResponsiveGrid',
    props: {
        columns: {
            type: Number,
            default: 5
        },
        minColumns: {
            type: Number,
            default: 1
        },
    },
    computed: {
        responsiveGridClasses() {
            // Compose Tailwind grid classes based on props
            let grids = {
                2: 'sm:grid-cols-2',
                3: 'md:grid-cols-3',
                4: 'lg:grid-cols-4',
                5: 'xl:grid-cols-5',
                6: '2xl:grid-cols-6',
                7: '3xl:grid-cols-7',
                8: '4xl:grid-cols-8',
            }
            // this.columns is max number of columns
            // remove any key that is greater than this.columns or less than this.minColumns
            let gridClasses = Object.keys(grids).reduce((acc, key) => {
                if (key <= this.columns && key >= this.minColumns) {
                    acc.push(grids[key]);
                }
                return acc;
            }, []);
            if(gridClasses.length > 0) {
                gridClasses.push(`grid-cols-${this.minColumns}`);
            }
            // add grid-cols-1 if there are no keys left
            if (gridClasses.length === 0) {
                gridClasses.push('grid-cols-1');
            }
            return gridClasses.join(' ');
        }
    }
};
</script>